import React, { useState, useEffect } from 'react';
import BlogDashboardFallback from './BlogDashboardFallback';

/**
 * Loader component for BlogDashboard that handles errors gracefully
 */
const BlogDashboardLoader = () => {
  const [Component, setComponent] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    
    const loadComponent = async () => {
      try {
        setLoading(true);
        
        // Dynamic import with timeout for better UX
        const timeout = new Promise(
          (_, reject) => setTimeout(() => reject(new Error('Import timeout')), 15000)
        );
        
        const importPromise = import('./BlogDashboard');
        const result = await Promise.race([importPromise, timeout]);
        
        // Only update state if component is still mounted
        if (isMounted) {
          const BlogDashboard = result.default;
          setComponent(() => BlogDashboard);
          setError(null);
        }
      } catch (err) {
        console.error('Error loading BlogDashboard:', err);
        
        // Only update state if component is still mounted
        if (isMounted) {
          setError(err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadComponent();
    
    // Cleanup function to prevent memory leaks
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  if (error || !Component) {
    return <BlogDashboardFallback error={error} />;
  }

  // Render the loaded component
  return <Component />;
};

export default BlogDashboardLoader; 